export class ErrorReportingService {
  constructor() {
    this.errors = []
    this.maxErrors = 100
  }

  captureException(error, context = {}) {
    const errorObj = {
      id: Date.now(),
      message: error.message,
      stack: error.stack,
      context,
      timestamp: new Date().toISOString(),
    }
    
    this.errors.unshift(errorObj)
    
    // Keep only last maxErrors
    if (this.errors.length > this.maxErrors) {
      this.errors.pop()
    }
    
    // In production, you could send to Sentry here
    if (import.meta.env.PROD && window.Sentry) {
      window.Sentry.captureException(error, { extra: context })
    }
    
    return errorObj
  }
  
  getErrors() {
    return this.errors
  }
  
  clearErrors() {
    this.errors = []
  }
}